module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Auswahl Types",
      "dark": "",
      "cache-items": "",
      "required": "",
      "items": _vm.types,
      "item-text": "name",
      "item-value": "id",
      "return-object": ""
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-195123f8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/typesSelectSingle.vue
// module id = 311
// module chunks = 0